import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseFailedConsumptionsProps<T> = {
  filters?: {
    page?: number
    status?: string
    clientCompanyId?: string
    clientBranchId?: string
    establishmentCompanyId?: string
    establishmentBranchId?: string
  }
  mapper?: (data: any) => T
}

export const useConsumptionsByStatus = <T,>({
  filters: { page, status, clientCompanyId, clientBranchId, establishmentCompanyId, establishmentBranchId } = {},
  mapper = Mapper.default<T>(),
}: UseFailedConsumptionsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: [
      'clientConsumptions',
      page,
      status,
      clientCompanyId,
      clientBranchId,
      establishmentCompanyId,
      establishmentBranchId,
    ],
    queryFn: () => {
      return privateAxios.get('/client/consumptions', {
        params: {
          page,
          'q[status_eq]': status,
          'q[client_company_id_eq]': clientCompanyId,
          'q[client_branch_id_eq]': clientBranchId,
          'q[establishment_company_id_eq]': establishmentCompanyId,
          'q[establishment_branch_id_eq]': establishmentBranchId,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => ({
      data: mapper(data?.data?.data),
      meta: data?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
